import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { HandHistoryRow } from "./HandHistoryRow";
import { EmptyMini } from "@/modules/collector_v2/components/common/EmptyMini";

export function HandHistoryTable({
  items = [],
  onToggleCollect,
  onOpenReplay,
  busyHandId = null,
  emptyLabel = "Sin manos para mostrar",
}) {
  if (!items || items.length === 0) {
    return <EmptyMini label={emptyLabel} />;
  }
  return (
    <div className="rounded-md border overflow-hidden">
      <Table data-testid="hand-history-table" aria-label="Historial de manos">
        <TableHeader>
          <TableRow className="bg-muted/40">
            <TableHead className="w-[90px]">Hand</TableHead>
            <TableHead>Mesa</TableHead>
            <TableHead className="w-[80px]">Juego</TableHead>
            <TableHead className="w-[60px]">Pos</TableHead>
            <TableHead className="w-[120px]">Cartas</TableHead>
            <TableHead className="w-[180px]">Board</TableHead>
            <TableHead className="w-[110px] text-right">Profit</TableHead>
            <TableHead className="w-[140px]">Fecha</TableHead>
            <TableHead className="w-[100px] text-right">Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((h) => (
            <HandHistoryRow
              key={h.hand_id}
              hand={h}
              onToggleCollect={onToggleCollect}
              onOpenReplay={onOpenReplay}
              busy={busyHandId === h.hand_id}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
